import { render, staticRenderFns } from "./NormalSearchNav124.vue?vue&type=template&id=f1affc20&scoped=true&"
import script from "./NormalSearchNav124.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav124.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1affc20",
  null
  
)

export default component.exports